// extracted by mini-css-extract-plugin
module.exports = {"invalid":"Invalid_invalid__OJAbt","invalid__logo":"Invalid_invalid__logo__DEci4"};